module.exports = __webpack_public_path__ + "img/11.2e911792.jpg";